<template>
  <!-- No telefone, superfície lisa de borda a borda — sem sombra nem cantos —, como o modal em tela
       cheia: o cartão em volta comia a largura que lá falta (relato do usuário). O fundo fica: é
       ele a superfície do formulário dentro do diálogo. -->
  <v-card :rounded="phone ? 0 : 'lg'" :variant="phone ? 'flat' : undefined" class="instance-card">
    <slot/>
  </v-card>
</template>

<script lang="ts">
import {Component, toNative, Vue} from 'vue-facing-decorator'

/**
 * A moldura de um ITEM: um card discreto.
 *
 * **Com o relevo do `v-card` padrão**, que é a variante `elevated` — a sombra é o que faz a
 * ficha parecer uma folha apoiada, e não um retângulo desenhado. Já tentei `flat border` aqui, e
 * sem a sombra o card virou um contorno: a moldura ficou visível e o relevo, que era a parte boa,
 * se perdeu. Só os cantos são mais macios que o padrão.
 *
 * **Uma peça só**, usada pela ficha e pelo painel de formulário, porque são duas telas do MESMO
 * item: ver e editar não podem ter aparência diferente. A edição ganhou o card primeiro, ao
 * passar a usar o painel; a ficha o ganhou depois, e a partir daqui as duas mudam juntas.
 *
 * **A régua do item não é daqui.** Ela fica ao lado do TÍTULO, onde sempre esteve, e por isso
 * este card não sabe nem precisa saber a cor de nada: é moldura, e só. Na borda ela foi
 * experimentada e não ficou boa — larga demais para um acento e longe demais do nome a que se
 * refere.
 */
@Component({name: 'ontos-instance-card'})
class InstanceCard extends Vue {
  /** O telefone — o mesmo `xs` em que o caminho some e os botões do cabeçalho viram ícone. */
  get phone(): boolean {
    return this.$vuetify.display.xs
  }
}

export default toNative(InstanceCard)
</script>

<style scoped>
/* Base para o que a ficha posiciona por dentro — as réguas de linha das tabelas de
   relacionamento dependem de um ancestral posicionado. */
.instance-card {
  position: relative;
}
</style>
